;(() => {
	const init = (section) => {
		let sectionNumbers

		if (document.currentScript) {
			sectionNumbers = document.currentScript.parentElement
		} else {
			sectionNumbers = section
		}

		if (
			!sectionNumbers ||
			!sectionNumbers.classList.contains('section-numbers')
		)
			return

		const getNumbers = () => {
			const odometerElems = sectionNumbers.querySelectorAll(
				'.numbers-card__number'
			)
			const regex = /[0-9]*[.,\s]?[0-9]*[.,\s]?[0-9]*[.,\s]?[0-9]+/g
			let nums = []

			odometerElems.forEach((el) => {
				nums.push(el.getAttribute('data-content').trim().match(regex))
			})

			return nums.flat(1)
		}

		const initNumbers = () => {
			const odometerElems = sectionNumbers.querySelectorAll(
				'.numbers-card__number'
			)
			const regex = /[0-9]*[.,\s]?[0-9]*[.,\s]?[0-9]*[.,\s]?[0-9]+/g

			odometerElems.forEach((el) => {
				el.innerHTML = el
					.getAttribute('data-content')
					.replace(regex, `<span class="js-num">$&</span>`)
			})
		}

		const numbers = getNumbers()
		let sectionObserver
		let sectionResizeObserver
		const activeAnimations = new Map()

		const analyzeNumberString = (rawNumber) => {
			const source = rawNumber.toString().trim()
			const dotCount = (source.match(/\./g) || []).length
			const commaCount = (source.match(/,/g) || []).length
			const spaceCount = (source.match(/\s/g) || []).length
			let decimalSeparator = ''
			let thousandSeparator = ''
			let decimals = 0

			if (dotCount && commaCount) {
				const lastDot = source.lastIndexOf('.')
				const lastComma = source.lastIndexOf(',')
				decimalSeparator = lastDot > lastComma ? '.' : ','
				thousandSeparator = decimalSeparator === '.' ? ',' : '.'
			} else if (dotCount || commaCount) {
				const separator = dotCount ? '.' : ','
				const separatorCount = dotCount || commaCount
				const lastIndex = source.lastIndexOf(separator)
				const digitsAfterSeparator = source.length - lastIndex - 1

				if (
					separatorCount === 1 &&
					digitsAfterSeparator > 0 &&
					digitsAfterSeparator !== 3
				) {
					decimalSeparator = separator
				} else if (
					separatorCount > 1 &&
					digitsAfterSeparator > 0 &&
					digitsAfterSeparator !== 3
				) {
					decimalSeparator = separator
				} else {
					thousandSeparator = separator
				}
			}

			if (!thousandSeparator && spaceCount > 0) {
				thousandSeparator = ' '
			}

			if (decimalSeparator) {
				const decimalPart = source.split(decimalSeparator).pop()
				decimals = decimalPart ? decimalPart.replace(/\D/g, '').length : 0
			}

			let normalized = source.replace(/\s/g, '')
			if (thousandSeparator && thousandSeparator !== ' ') {
				normalized = normalized.split(thousandSeparator).join('')
			}
			if (decimalSeparator && decimalSeparator !== '.') {
				normalized = normalized.replace(decimalSeparator, '.')
			}
			if (!decimalSeparator) {
				normalized = normalized.replace(/[.,]/g, '')
			}

			const target = Number.parseFloat(normalized)

			return {
				target: Number.isFinite(target) ? target : 0,
				decimals,
				decimalSeparator,
				thousandSeparator,
			}
		}

		const formatNumber = (value, meta) => {
			const safeValue = Number.isFinite(value) ? value : 0
			const fixed = meta.decimals > 0 ? safeValue.toFixed(meta.decimals) : Math.round(safeValue).toString()
			let [integerPart, decimalPart] = fixed.split('.')
			const thousandSeparator = meta.thousandSeparator || ''

			if (thousandSeparator) {
				integerPart = integerPart.replace(
					/\B(?=(\d{3})+(?!\d))/g,
					thousandSeparator
				)
			}

			if (meta.decimals > 0) {
				return `${integerPart}${meta.decimalSeparator || '.'}${decimalPart}`
			}

			return integerPart
		}

		const stopAnimation = (el) => {
			const frameId = activeAnimations.get(el)
			if (frameId) {
				cancelAnimationFrame(frameId)
				activeAnimations.delete(el)
			}
		}

		const animateNumber = (el, rawNumber) => {
			if (!el || rawNumber == null) return
			stopAnimation(el)

			const meta = analyzeNumberString(rawNumber)
			const duration = 1400
			const startTime = performance.now()

			el.textContent = formatNumber(0, meta)

			const tick = (now) => {
				const progress = Math.min((now - startTime) / duration, 1)
				const easedProgress = 1 - Math.pow(1 - progress, 3)
				const currentValue = meta.target * easedProgress

				el.textContent = formatNumber(currentValue, meta)

				if (progress < 1) {
					const frameId = requestAnimationFrame(tick)
					activeAnimations.set(el, frameId)
				} else {
					el.textContent = formatNumber(meta.target, meta)
					activeAnimations.delete(el)
				}
			}

			const frameId = requestAnimationFrame(tick)
			activeAnimations.set(el, frameId)
		}

		const initSlider = () => {
			let numbersSlider
			let navigation
			let pagination

			numbersSlider = sectionNumbers.querySelector('.js-slider-numbers')

			navigation = sectionNumbers.querySelector('.numbers__navigation')
			pagination = sectionNumbers.querySelector('.numbers__pagination')

			if (numbersSlider) {
				const numbersSwiper = new Swiper(numbersSlider, {
					slidesPerView: 1,
					spaceBetween: 1,
					mousewheel: {
						forceToAxis: true,
					},
					speed: 1000,
					loop: true,
					navigation: {
						nextEl: navigation?.querySelector('.swiper-button-next'),
						prevEl: navigation?.querySelector('.swiper-button-prev'),
					},
					pagination: {
						el: pagination,
						clickable: true,
					},
					on: {
						slideChangeTransitionStart: function () {
							const activeSlide = this.el.querySelector('.swiper-slide-active')
							const slideIndex = Number.parseInt(
								activeSlide?.dataset?.swiperSlideIndex || this.activeIndex,
								10
							)
							const activeNum = activeSlide?.querySelector('.js-num')

							if (activeNum && numbers[slideIndex]) {
								animateNumber(activeNum, numbers[slideIndex])
							}
						},
					},
				})
			}
		}

		const initSection = () => {
			sectionObserver = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						entry.target.querySelectorAll('.js-num').forEach((num, i) => {
							animateNumber(num, numbers[i])
						})
					} else {
						entry.target.querySelectorAll('.js-num').forEach((num, i) => {
							stopAnimation(num)
							num.textContent = formatNumber(0, analyzeNumberString(numbers[i]))
						})
					}
				})
			})

			sectionObserver.observe(sectionNumbers.querySelector('.numbers__outer'))

			sectionResizeObserver = new ResizeObserver((entries) => {
				const [entry] = entries
				const sliders = entry.target.querySelectorAll('.js-slider-numbers')

				if (sliders.length != 0) {
					sliders.forEach((slider) => {
						if (slider.swiper) slider.swiper.destroy()
					})
				}

				initSlider(sectionNumbers)
			})

			initNumbers()

			sectionResizeObserver.observe(sectionNumbers)
		}

		initSection()
		initSlider()

		sectionNumbers.addEventListener('shopify:section:unload', () => {
			activeAnimations.forEach((frameId) => cancelAnimationFrame(frameId))
			activeAnimations.clear()
			if (sectionObserver) sectionObserver.disconnect()
			if (sectionResizeObserver) sectionResizeObserver.disconnect()
		})
	}

	init()

	document.addEventListener('shopify:section:load', function (section) {
		init(section.target)
	})
})()
